import { InputText } from 'primereact/inputtext';
import { ITableBaseFilterData } from 'src/api/types/table';
import { FILTER_TYPES } from 'src/enums/table';

const TextFilter: React.FC<Omit<ITableBaseFilterData<FILTER_TYPES.TEXT>, 'config'>> = ({ defaultValue, name, label, onChange }) => {
    return <InputText type="search" placeholder={`Search in ${label}`} id={name} name={name} value={defaultValue} onChange={onChange} />;
};

export default TextFilter;
